// Copyright: IQGeo Limited 2010-2019
import geometry from './geomFactory';

/* globals turf: false */

/**
 * Mixin with common behaviour for any type of geometry
 * @mixin GeometryMixin
 */

/** @lends GeometryMixin.prototype */
const GeometryMixin = {
    initialize(coordinates) {
        if (coordinates) this.coordinates = coordinates;
    },

    /**
     * Calculate a buffer around self's geometry
     * @param  {number} size
     * @param  {unit}   [unit='meters']
     * @return {Polygon}
     */
    buffer(size, unit) {
        this.assertTurf();
        const buffer = turf.buffer(this, size, { units: unit || 'meters' });
        return geometry(buffer.geometry);
    },

    /**
     * Self's bounding box
     * @return {Number[]} bbox extent in minX, minY, maxX, maxY order
     */
    bbox() {
        return turf.bbox(this);
    },

    /**
     * Returns true if self wholy contains a given geometry
     * @param {Geometry} other
     */
    contains(other) {
        return turf.booleanContains(this.noProto(), other.noProto());
    },

    /**
     * Self's bounding box as a polygon
     * @return {Polygon}
     */
    bboxPolygon() {
        const polygon = turf.bboxPolygon(this.bbox());
        return geometry(polygon.geometry);
    },

    assertTurf() {
        if (typeof turf == 'undefined')
            throw new Error(
                'Geometry module not yet initialized. Ensure geometry.init() has resolved.'
            );
    },

    /**
     * Returns self as part of a mock GeoJson feature
     * @return {object}
     * @private
     */
    _asFeature() {
        return { type: 'Feature', geometry: this.noProto() };
    },

    /**
     * Returns self as a GeoJson geometry with no additional behaviour (i.e. no prototype chain)
     * Usefull when other turf tries to identify type by checking for length etc...
     * @return {object}
     * @private
     */
    noProto() {
        return { type: this.type, coordinates: this.coordinates };
    }
};

export default GeometryMixin;
